import axios from "axios";

// Dedicated client for the Phase 2 /api/v1 namespace.
// Separate from services/api.js (the existing app) so nothing changes there.
const BASE = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");

// Access token lives in memory only (never localStorage) — the refresh
// token is an httpOnly cookie the browser sends automatically.
let accessToken = null;
export const setAccessToken = (t) => {
  accessToken = t || null;
};
export const getAccessToken = () => accessToken;

let onLogout = () => {};
export const setOnLogout = (fn) => {
  onLogout = fn || (() => {});
};

const apiV1 = axios.create({
  baseURL: `${BASE}/api/v1`,
  withCredentials: true,
  timeout: 30000,
  headers: { "Content-Type": "application/json" },
});

apiV1.interceptors.request.use((config) => {
  if (accessToken) config.headers.Authorization = `Bearer ${accessToken}`;
  return config;
});

// Shared, de-duplicated refresh using the rotating httpOnly cookie.
// Exported so the legacy /api client can reuse the same session.
let refreshing = null;
export function refreshAccessToken() {
  if (!refreshing) {
    refreshing = axios
      .post(`${BASE}/api/v1/auth/refresh`, {}, { withCredentials: true })
      .then((r) => {
        setAccessToken(r.data.data.accessToken);
        return r.data.data.accessToken;
      })
      .finally(() => {
        refreshing = null;
      });
  }
  return refreshing;
}

// On a 401, try one silent refresh, then retry once.
apiV1.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    const is401 = error.response?.status === 401;
    const isAuthCall = original?.url?.includes("/auth/");

    if (is401 && original && !original._retry && !isAuthCall) {
      original._retry = true;
      try {
        const newToken = await refreshAccessToken();
        original.headers.Authorization = `Bearer ${newToken}`;
        return apiV1(original);
      } catch (e) {
        setAccessToken(null);
        onLogout();
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export default apiV1;
